import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { ActivityConditionType } from "../../../models/activity-condition-type";
import { DocumentRejectionTranslation } from "../../../models/document-rejection-translation";
import { ActivityConditionTypeControllerService } from "../../../services/classifications-controller/activity-condition-type-controller.service";
import { LanguageControllerService } from "../../../services/language-controller/language-controller.service";
import { BaseError } from "../base-error";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";

@Component({
  selector: "activity-condition-type",
  templateUrl: "./activity-condition-type.component.html",
  providers: [ToastrService],
})

export class ActivityConditionTypeComponent extends BaseError implements OnInit {

  @Output() public sendCounter = new EventEmitter();
  public activityConditionTypes: ActivityConditionType[] = [];
  public name = "";
  public languages: any[] = [];
  public isLoading: boolean = false;

  public lastOrder: any = null;
  private alphabeticalOrderReference: any = { value: true, key: true };

  constructor(private conditionTypeControllerService: ActivityConditionTypeControllerService,
              private languageService: LanguageControllerService,
              toastr: ToastrService) {
    super(toastr);
  }

  public ngOnInit() {
    this.loadLanguages();
    this.loadActivityConditionTypes();
  }

  public loadLanguages() {
    this.languageService.getLanguages().subscribe(
      (data) => this.languages = data,
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service ", error),
    );
  }

  public loadActivityConditionTypes() {
    this.conditionTypeControllerService.getConditionTypes().subscribe(
      (data) => {
        this.activityConditionTypes = data;
        this.sendCounter.emit(data?.length);
        this.activityConditionTypes.sort((a, b) => a.sortOrder - b.sortOrder);
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public addNewActivityConditionType() {
    const conditionType = new ActivityConditionType();
    conditionType.name = this.name;
    this.activityConditionTypes.push(conditionType);
    this.saveActivityConditionType();
  }

  public removeActivityConditionType(isConfirmed, id: string) {
    if (isConfirmed) {
      const newList: ActivityConditionType[] = [];
      for (const conditionType of this.activityConditionTypes) {
        if (conditionType.id !== id) {
          newList.push(conditionType);
        }
      }
      this.activityConditionTypes = newList;
      this.saveActivityConditionType();
    }
  }

  public saveActivityConditionType(removeSort: boolean = true) {

    if (removeSort) {
      this.removeSort();
    }

    if (!this.isLoading) {
      this.isLoading = true;

      // set order
      this.setOrder();

      this.conditionTypeControllerService.saveConditionType(this.activityConditionTypes).subscribe(
        (data) => {
          this.name = "";
          this.updateSortOrderConditionType();
          this.responseSuccessful("Data is saved!");
        },
        (error) => this.showErrorMessage(error),
        () => this.isLoading = false,
      );
    }
  }

  public updateSortOrderConditionType() {
    this.activityConditionTypes.sort((a, b) => a.sortOrder - b.sortOrder);
    this.conditionTypeControllerService.updateSortOrder(this.activityConditionTypes).subscribe();
  }

  public getTranslation(lan: string, id: string): string {
    let result;
    for (const activityConditionType of this.activityConditionTypes) {
      if (activityConditionType.id === id) {
        for (const activityConditionTypeTranslation of activityConditionType.translations) {
          if (lan === activityConditionTypeTranslation.languageCode) {
            result = activityConditionTypeTranslation.name;
          }
        }
      }
    }
    return result;
  }

  public setTranslation(value: any, lan: string, id: string): void {
    let isUpdated = false;
    for (const activityConditionType of this.activityConditionTypes) {
      if (activityConditionType.id === id) {
        for (const documentRejectionTranslation of activityConditionType.translations) {
          if (lan === documentRejectionTranslation.languageCode) {
            documentRejectionTranslation.name = value;
            isUpdated = true;
          }
        }
        if (isUpdated === false) {
          const translation = new DocumentRejectionTranslation();
          translation.name = value;
          translation.languageCode = lan;
          activityConditionType.translations.push(translation);
        }
      }
    }
  }

  public dropped(event: CdkDragDrop<ActivityConditionType[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      // component logic
      this.saveActivityConditionType();
    }
  }

  public sortItems(key: string): void {
    this.alphabeticalOrderReference[key] = !this.alphabeticalOrderReference[key];
    this.lastOrder = Object.assign([], this.activityConditionTypes);
    this.activityConditionTypes.sort((fieldA, fieldB) => {
      return this.alphabeticalOrderReference[key]
        ? (fieldA[key].toLowerCase() > fieldB[key].toLowerCase() ? -1 : 1)
        : (fieldA[key].toLowerCase() > fieldB[key].toLowerCase() ? 1 : -1);
    });
    this.saveActivityConditionType(false);
  }

  public removeSort() {
    // for clean force order
    this.lastOrder = null;
  }

  public setOrder() {
    let customOrderIndex = 0;
    this.activityConditionTypes.forEach((f) => {
      f.sortOrder = customOrderIndex;
      customOrderIndex++;
    });
  }

  public revertSort() {
    this.activityConditionTypes = this.lastOrder;
    this.saveActivityConditionType(true);
  }

}
